import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

export default function FormColorPicker({ name, label, ...props }) {
  const { control } = useFormContext();
  const colorInputRef = React.useRef(null);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            onClick={() => colorInputRef.current?.click()}
            sx={{
              width: 40,
              height: 40,
              borderRadius: 1,
              bgcolor: field.value || '#cccccc',
              cursor: 'pointer',
              border: '1px solid',
              borderColor: 'divider',
              flexShrink: 0,
            }}
          />
          <input
            ref={colorInputRef}
            type="color"
            value={field.value || '#cccccc'}
            onChange={(e) => field.onChange(e.target.value)}
            style={{ display: 'none' }}
          />
          <TextField
            {...field}
            label={label}
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message || 'Hex colour e.g. #003B6F'}
            inputProps={{ maxLength: 7 }}
            InputProps={{
              startAdornment: <InputAdornment position="start">#</InputAdornment>,
            }}
            onChange={(e) => {
              let val = e.target.value;
              if (val && !val.startsWith('#')) val = '#' + val;
              field.onChange(val);
            }}
            {...props}
          />
        </Box>
      )}
    />
  );
}
